import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_JOB_BOARD_API_URL;

/**
 * Common auth header helper
 */
const authHeader = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

/* ============================
   DASHBOARD
============================ */

export const getJobSeekerDashboardSummary = async (token, seeker_id) => {
  if (!seeker_id) throw new Error("seeker_id is required");

  const response = await axios.get(
    `${API_BASE_URL}/job-seeker/${seeker_id}/dashboard/summary`,
    authHeader(token)
  );
  return response.data;
};

/* ============================
   APPLICATIONS
============================ */

export const getJobSeekerApplications = async (token, seeker_id) => {
  if (!seeker_id) throw new Error("seeker_id is required");

  const response = await axios.get(
    `${API_BASE_URL}/job-seeker/${seeker_id}/applications`,
    authHeader(token)
  );
  return response.data;
};

export const getRecentJobSeekerApplications = async (token, seeker_id) => {
  if (!seeker_id) throw new Error("seeker_id is required");

  const response = await axios.get(
    `${API_BASE_URL}/job-seeker/${seeker_id}/applications/recent`,
    authHeader(token)
  );
  return response.data;
};

export const getApplicationTimeline = async (token, seeker_id, applicationId) => {
  if (!seeker_id) throw new Error("seeker_id is required");

  const response = await axios.get(
    `${API_BASE_URL}/job-seeker/${seeker_id}/applications/${applicationId}/timeline`,
    authHeader(token)
  );
  return response.data;
};

/* ============================
   JOBS
============================ */

export const getSuggestedJobs = async (token, seeker_id) => {
  if (!seeker_id) throw new Error("seeker_id is required");

  const response = await axios.get(
    `${API_BASE_URL}/job-seeker/${seeker_id}/jobs/suggested`,
    authHeader(token)
  );
  return response.data;
};

export const applyJob = async (token, seeker_id, jobId) => {
  if (!seeker_id) throw new Error("seeker_id is required");

  const response = await axios.post(
    `${API_BASE_URL}/job-seeker/${seeker_id}/jobs/${jobId}/apply`,
    {},
    authHeader(token)
  );
  return response.data;
};

/* ============================
   PROFILE
============================ */

// export const getProfileCompletion = async (token, seeker_id) => {
//   if (!seeker_id) throw new Error("seeker_id is required");

//   const response = await axios.get(
//     `${API_BASE_URL}/job-seeker/${seeker_id}/profile/completion`,
//     authHeader(token)
//   );
//   return response.data;
// };

/* ============================
   RESUMES
============================ */

export const getResumes = async (token, seeker_id) => {
  if (!seeker_id) throw new Error("seeker_id is required");

  const response = await axios.get(
    `${API_BASE_URL}/job-seeker/${seeker_id}/resumes`,
    authHeader(token)
  );
  return response.data;
};

export const uploadResume = async (token, seeker_id, payload) => {
  if (!seeker_id) throw new Error("seeker_id is required");

  const response = await axios.post(
    `${API_BASE_URL}/job-seeker/${seeker_id}/resumes/upload`,
    payload,
    authHeader(token)
  );
  return response.data;
};

export const deleteResume = async (token, seeker_id, resumeId) => {
  if (!seeker_id) throw new Error("seeker_id is required");

  const response = await axios.delete(
    `${API_BASE_URL}/job-seeker/${seeker_id}/resumes/${resumeId}`,
    authHeader(token)
  );
  return response.data;
};

/* ============================
   INTERVIEWS
============================ */

export const getInterviewSchedule = async (token, seeker_id) => {
  if (!seeker_id) throw new Error("seeker_id is required");

  const response = await axios.get(
    `${API_BASE_URL}/job-seeker/${seeker_id}/interviews`,
    authHeader(token)
  );
  return response.data;
};
